/**
 * Genexa GX Header — scoped mega menus, drawer, testimonials
 * One instance per .gx-header-root; survives Theme Editor via shopify:section:load
 */
(function () {
  'use strict';

  var roots = new WeakMap();
  var cartSyncBound = false;
  var CART_UPDATE_EVENT = 'wetheme-cart-update';

  function parseTrustJson(root) {
    var el = root.querySelector('[data-gx-trust-json]');
    if (!el || !el.textContent.trim()) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function getShopifyRoutesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function cartAriaLabel(root, count) {
    var template = root.getAttribute('data-gx-cart-aria-label') || 'Cart, [count] items';
    return template.replace(/\[count\]/g, String(count));
  }

  function syncGxCartCount(root, count) {
    if (!root) return;
    var n = typeof count === 'number' ? count : parseInt(count, 10);
    if (isNaN(n)) n = 0;
    var showZero = root.getAttribute('data-gx-cart-show-zero') === 'true';
    var hasItems = n > 0;

    root.querySelectorAll('[data-gx-cart-count]').forEach(function (badge) {
      badge.textContent = n;
      badge.classList.toggle('gx-cart-badge--hidden', !hasItems && !showZero);
    });

    root.querySelectorAll('[data-gx-cart-trigger], .gx-cart-trigger').forEach(function (trigger) {
      trigger.setAttribute('aria-label', cartAriaLabel(root, n));
    });
  }

  function openThemeCartDrawer() {
    if (window.eventBus && typeof window.eventBus.emit === 'function') {
      window.eventBus.emit('open:cart:drawer', { scrollToTop: false });
      return true;
    }
    var drawer = document.getElementById('CartDrawer');
    if (drawer && typeof drawer.openDrawer === 'function') {
      drawer.openDrawer();
      return true;
    }
    return false;
  }

  function bindGlobalCartCountSync() {
    if (cartSyncBound) return;
    cartSyncBound = true;

    document.documentElement.addEventListener(CART_UPDATE_EVENT, function (e) {
      var count = e.detail && e.detail.cart ? e.detail.cart.item_count : null;
      if (count == null) return;
      document.querySelectorAll('.gx-header-root').forEach(function (root) {
        syncGxCartCount(root, count);
      });
    });

    if (window.eventBus && typeof window.eventBus.on === 'function') {
      window.eventBus.on('cart:added', function () {
        fetchGxCartCount();
      });
      window.eventBus.on('update:cart:drawer', function (e) {
        if (e && e.cart && typeof e.cart.item_count === 'number') {
          document.querySelectorAll('.gx-header-root').forEach(function (root) {
            syncGxCartCount(root, e.cart.item_count);
          });
        }
      });
    }
  }

  function fetchGxCartCount() {
    var rootPath = getShopifyRoutesRoot();
    fetch(rootPath + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        document.querySelectorAll('.gx-header-root').forEach(function (root) {
          syncGxCartCount(root, cart.item_count);
        });
        if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
          window.wetheme.updateCartCount(cart);
        }
      })
      .catch(function () {});
  }

  function initGxCart(root, sig) {
    bindGlobalCartCountSync();

    var useDrawer = root.getAttribute('data-gx-cart-drawer') === 'true';
    var triggers = root.querySelectorAll('[data-gx-cart-trigger]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener(
        'click',
        function (e) {
          if (!useDrawer) return;
          e.preventDefault();
          if (!openThemeCartDrawer()) {
            window.location.href = trigger.getAttribute('href') || '/cart';
          }
        },
        sig
      );
    });

    var badge = root.querySelector('[data-gx-cart-count]');
    if (badge) {
      var initial = parseInt(badge.textContent, 10);
      if (!isNaN(initial)) syncGxCartCount(root, initial);
    }
  }

  var RECENT_STORAGE_KEY = 'gxHeaderRecentProducts';

  function tryRecordProductViewFromPath() {
    if (window.Shopify && window.Shopify.designMode) return;
    var path = window.location.pathname || '';
    var m = path.match(/\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)/i);
    if (!m) m = path.match(/\/products\/([^/?#]+)/);
    if (!m || !m[1]) return;
    var handle = decodeURIComponent(m[1]);
    if (!handle || handle.length > 128) return;
    pushRecentProductHandle(handle);
  }

  function pushRecentProductHandle(handle) {
    try {
      var raw = localStorage.getItem(RECENT_STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(arr)) arr = [];
      arr = arr.filter(function (h) {
        return h !== handle;
      });
      arr.unshift(handle);
      if (arr.length > 12) arr = arr.slice(0, 12);
      localStorage.setItem(RECENT_STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {}
  }

  function getRecentProductHandles(max) {
    try {
      var raw = localStorage.getItem(RECENT_STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(arr)) return [];
      return arr.slice(0, max || 2);
    } catch (e) {
      return [];
    }
  }

  function productJsonImageUrl(p) {
    if (!p) return '';
    if (typeof p.featured_image === 'string') return p.featured_image;
    if (p.featured_image && typeof p.featured_image === 'object' && p.featured_image.src) {
      return p.featured_image.src;
    }
    if (p.images && p.images.length) {
      var im = p.images[0];
      if (typeof im === 'string') return im;
      if (im && im.src) return im.src;
    }
    return '';
  }

  function fetchProductJs(handle) {
    var url = getShopifyRoutesRoot() + 'products/' + encodeURIComponent(handle) + '.js';
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function renderSearchRecentProducts(headerRoot) {
    var wrap = headerRoot.querySelector('[data-gx-search-recent]');
    var grid = headerRoot.querySelector('[data-gx-search-recent-grid]');
    if (!wrap || !grid) return;
    if (headerRoot.getAttribute('data-gx-search-recent-enabled') !== 'true') {
      wrap.setAttribute('hidden', '');
      return;
    }
    var handles = getRecentProductHandles(2);
    if (handles.length === 0) {
      wrap.setAttribute('hidden', '');
      grid.innerHTML = '';
      return;
    }
    wrap.removeAttribute('hidden');
    grid.innerHTML = '';
    Promise.all(handles.map(fetchProductJs)).then(function (products) {
      products.filter(Boolean).forEach(function (p) {
        var href = p.url || getShopifyRoutesRoot() + 'products/' + encodeURIComponent(p.handle);
        var a = document.createElement('a');
        a.href = href;
        a.className = 'gx-search-recent-card';
        var imgUrl = productJsonImageUrl(p);
        if (imgUrl) {
          var sep = imgUrl.indexOf('?') >= 0 ? '&' : '?';
          var img = document.createElement('img');
          img.src = imgUrl + sep + 'width=240';
          img.alt = p.title || '';
          img.className = 'gx-search-recent-card-img';
          img.loading = 'lazy';
          img.width = 120;
          img.height = 120;
          a.appendChild(img);
        }
        var body = document.createElement('div');
        body.className = 'gx-search-recent-card-body';
        var title = document.createElement('span');
        title.className = 'gx-search-recent-card-title';
        title.textContent = p.title || '';
        body.appendChild(title);
        a.appendChild(body);
        grid.appendChild(a);
      });
    });
  }

  function initGxHeader(root) {
    if (!root || roots.has(root)) return;
    var ac = new AbortController();
    var sig = { signal: ac.signal };
    var bundle = { controller: ac, observer: null };
    roots.set(root, bundle);

    var openBtn = root.querySelector('[data-gx-drawer-open]');
    var closeBtn = root.querySelector('[data-gx-drawer-close]');
    var drawer = root.querySelector('[data-gx-drawer]');
    var overlay = root.querySelector('[data-gx-overlay]');
    var navItems = Array.from(root.querySelectorAll('.gx-nav-item'));
    var accordions = Array.from(root.querySelectorAll('.gx-drawer-acc'));

    var lastFocusedBeforeDrawer = null;
    var drawerMobileMq = window.matchMedia('(max-width: 989px)');

    function isDrawerOpen() {
      return !!(drawer && drawer.classList.contains('is-open'));
    }

    /** Closed drawer: inert + aria-hidden; on desktop also `hidden` (BUG-COL-01). */
    function applyDrawerClosedA11y() {
      if (!drawer || isDrawerOpen()) return;
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      if (!drawerMobileMq.matches) {
        drawer.setAttribute('hidden', '');
      } else {
        drawer.removeAttribute('hidden');
      }
    }

    function applyDrawerOpenA11y() {
      if (!drawer) return;
      drawer.removeAttribute('hidden');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
    }

    function onDrawerViewportChange() {
      if (!drawer) return;
      if (!drawerMobileMq.matches && isDrawerOpen()) {
        closeDrawer();
        return;
      }
      applyDrawerClosedA11y();
    }

    if (typeof drawerMobileMq.addEventListener === 'function') {
      drawerMobileMq.addEventListener('change', onDrawerViewportChange);
    } else if (typeof drawerMobileMq.addListener === 'function') {
      drawerMobileMq.addListener(onDrawerViewportChange);
    }
    ac.signal.addEventListener('abort', function () {
      if (typeof drawerMobileMq.removeEventListener === 'function') {
        drawerMobileMq.removeEventListener('change', onDrawerViewportChange);
      } else if (typeof drawerMobileMq.removeListener === 'function') {
        drawerMobileMq.removeListener(onDrawerViewportChange);
      }
    });

    applyDrawerClosedA11y();

    initGxCart(root, sig);

    navItems.forEach(function (item) {
      var mega = item.querySelector('.gx-mega');
      var toggle = item.querySelector('.gx-nav-toggle');
      if (mega) {
        mega.setAttribute('inert', '');
        mega.setAttribute('aria-hidden', 'true');
      }
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });

    function closeAllMegas(focusReturnTarget) {
      navItems.forEach(function (item) {
        var wasOpen = item.classList.contains('is-open');
        item.classList.remove('is-open');
        var mega = item.querySelector('.gx-mega');
        var toggle = item.querySelector('.gx-nav-toggle');
        if (mega) {
          mega.setAttribute('inert', '');
          mega.setAttribute('aria-hidden', 'true');
        }
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (wasOpen && focusReturnTarget) focusReturnTarget.focus();
      });
    }

    function openMega(item) {
      navItems.forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          var m = other.querySelector('.gx-mega');
          var t = other.querySelector('.gx-nav-toggle');
          if (m) {
            m.setAttribute('inert', '');
            m.setAttribute('aria-hidden', 'true');
          }
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.add('is-open');
      var mega = item.querySelector('.gx-mega');
      var toggle = item.querySelector('.gx-nav-toggle');
      if (mega) {
        mega.removeAttribute('inert');
        mega.setAttribute('aria-hidden', 'false');
      }
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function toggleMega(item) {
      if (item.classList.contains('is-open')) closeAllMegas();
      else openMega(item);
    }

    navItems.forEach(function (item) {
      var toggle = item.querySelector('.gx-nav-toggle');
      if (!toggle) return;

      toggle.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          toggleMega(item);
        },
        sig
      );

      toggle.addEventListener(
        'keydown',
        function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            openMega(item);
            var firstLink = item.querySelector('.gx-mega a, .gx-mega button');
            if (firstLink) firstLink.focus();
          } else if (e.key === 'Escape') {
            if (item.classList.contains('is-open')) {
              e.preventDefault();
              closeAllMegas(toggle);
            }
          }
        },
        sig
      );
    });

    navItems.forEach(function (item) {
      item.addEventListener(
        'mouseenter',
        function () {
          if (window.matchMedia('(hover: hover)').matches) openMega(item);
        },
        sig
      );
      item.addEventListener(
        'mouseleave',
        function () {
          if (window.matchMedia('(hover: hover)').matches) {
            item.classList.remove('is-open');
            var m = item.querySelector('.gx-mega');
            var t = item.querySelector('.gx-nav-toggle');
            if (m) {
              m.setAttribute('inert', '');
              m.setAttribute('aria-hidden', 'true');
            }
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        },
        sig
      );
    });

    root.querySelectorAll('.gx-mega').forEach(function (mega) {
      mega.addEventListener(
        'keydown',
        function (e) {
          if (e.key === 'Escape') {
            e.preventDefault();
            var navItem = mega.closest('.gx-nav-item');
            var toggle = navItem && navItem.querySelector('.gx-nav-toggle');
            closeAllMegas(toggle);
          }
        },
        sig
      );
    });

    var searchLayer = root.querySelector('[data-gx-search-layer]');
    var searchOpenBtns = Array.from(root.querySelectorAll('[data-gx-search-open]'));
    var lastFocusedBeforeSearch = null;

    function isSearchLayerOpen() {
      return !!(searchLayer && searchLayer.classList.contains('gx-search-layer--open'));
    }

    function closeSearchLayer() {
      if (!isSearchLayerOpen()) return;
      searchLayer.classList.remove('gx-search-layer--open');
      searchLayer.setAttribute('aria-hidden', 'true');
      searchOpenBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      var mr = searchLayer.querySelector('[data-gx-predictive-results]');
      var si = searchLayer.querySelector('[data-gx-predictive-input]');
      if (mr) {
        mr.innerHTML = '';
        mr.setAttribute('hidden', '');
      }
      if (si) si.setAttribute('aria-expanded', 'false');
      if (lastFocusedBeforeSearch && typeof lastFocusedBeforeSearch.focus === 'function') {
        lastFocusedBeforeSearch.focus();
      }
      lastFocusedBeforeSearch = null;
    }

    function openSearchLayer() {
      if (!searchLayer) return;
      if (!isSearchLayerOpen()) {
        lastFocusedBeforeSearch = document.activeElement;
      }
      closeAllMegas();
      searchLayer.classList.add('gx-search-layer--open');
      searchLayer.setAttribute('aria-hidden', 'false');
      searchOpenBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
      var inp = searchLayer.querySelector('input[name="q"]');
      requestAnimationFrame(function () {
        if (inp) inp.focus();
      });
      renderSearchRecentProducts(root);
    }

    searchOpenBtns.forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          if (isSearchLayerOpen()) closeSearchLayer();
          else openSearchLayer();
        },
        sig
      );
    });

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Escape') return;
        if (isSearchLayerOpen()) {
          e.preventDefault();
          closeSearchLayer();
        }
      },
      sig
    );

    function docClick(e) {
      if (!root.contains(e.target)) {
        closeAllMegas();
        closeSearchLayer();
        return;
      }
      if (!e.target.closest('.gx-nav-item')) closeAllMegas();
      if (
        searchLayer &&
        !e.target.closest('[data-gx-search-layer]') &&
        !e.target.closest('[data-gx-search-open]')
      ) {
        closeSearchLayer();
      }
    }
    document.addEventListener('click', docClick, sig);

    var predictiveEnabled = root.getAttribute('data-gx-predictive') === 'true';
    var predictiveSectionId = root.getAttribute('data-gx-predictive-section-id') || 'gx-predictive-search';
    var predictiveLimit = parseInt(root.getAttribute('data-gx-predictive-limit') || '8', 10);
    var predictiveMinChars = parseInt(root.getAttribute('data-gx-predictive-min-chars') || '2', 10);

    function initPredictiveSearch() {
      if (!predictiveEnabled) return;

      root.querySelectorAll('[data-gx-predictive-root]').forEach(function (proot) {
        var input = proot.querySelector('[data-gx-predictive-input]');
        var mount = proot.querySelector('[data-gx-predictive-results]');
        var live = proot.querySelector('[data-gx-predictive-live]');
        if (!input || !mount) return;

        var debounceTimer = null;
        var fetchController = null;

        function clearMount() {
          mount.innerHTML = '';
          mount.setAttribute('hidden', '');
          input.setAttribute('aria-expanded', 'false');
          if (live) live.textContent = '';
        }

        function parseSuggestHtml(text) {
          var docHtml = new DOMParser().parseFromString(text, 'text/html');
          var sec = docHtml.querySelector('#shopify-section-' + predictiveSectionId);
          if (!sec) return '';
          return sec.innerHTML;
        }

        function fetchSuggest(q) {
          if (fetchController) fetchController.abort();
          fetchController = new AbortController();
          var base = getShopifyRoutesRoot();
          var u =
            base +
            'search/suggest?q=' +
            encodeURIComponent(q) +
            '&section_id=' +
            encodeURIComponent(predictiveSectionId) +
            '&resources[type]=query%2Cproduct' +
            '&resources[limit_scope]=each' +
            '&resources[limit]=' +
            encodeURIComponent(String(predictiveLimit)) +
            '&resources[options][unavailable_products]=last';

          fetch(u, { signal: fetchController.signal, headers: { Accept: 'text/html' } })
            .then(function (res) {
              if (!res.ok) throw new Error(String(res.status));
              return res.text();
            })
            .then(function (text) {
              var html = parseSuggestHtml(text);
              if (!html.trim()) {
                clearMount();
                return;
              }
              mount.innerHTML = html;
              mount.removeAttribute('hidden');
              input.setAttribute('aria-expanded', 'true');
              if (live) live.textContent = 'Results updated.';
            })
            .catch(function () {
              clearMount();
            });
        }

        function scheduleFetch() {
          var q = input.value.trim();
          if (q.length < predictiveMinChars) {
            if (fetchController) fetchController.abort();
            clearTimeout(debounceTimer);
            clearMount();
            return;
          }
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            fetchSuggest(q);
          }, 280);
        }

        input.addEventListener('input', scheduleFetch, sig);
        input.addEventListener('focus', scheduleFetch, sig);
      });
    }

    initPredictiveSearch();

    tryRecordProductViewFromPath();

    var focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    function getDrawerFocusables() {
      if (!drawer || drawer.getAttribute('aria-hidden') === 'true' || drawer.hasAttribute('inert')) {
        return [];
      }
      return Array.from(drawer.querySelectorAll(focusableSelector)).filter(function (el) {
        return el.offsetParent !== null && !el.closest('[hidden], [inert]');
      });
    }

    function openDrawer() {
      closeSearchLayer();
      lastFocusedBeforeDrawer = document.activeElement;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      if (drawer) {
        drawer.removeAttribute('hidden');
        drawer.classList.add('is-open');
        applyDrawerOpenA11y();
      }
      if (overlay) {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        overlay.removeAttribute('inert');
      }
      document.documentElement.classList.add('gx-no-scroll');

      requestAnimationFrame(function () {
        if (closeBtn) closeBtn.focus();
      });
    }

    function closeDrawer() {
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('inert', '');
      }
      document.documentElement.classList.remove('gx-no-scroll');
      applyDrawerClosedA11y();

      if (drawer) {
        var dMount = drawer.querySelector('[data-gx-predictive-results]');
        var dInput = drawer.querySelector('[data-gx-predictive-input]');
        if (dMount) {
          dMount.innerHTML = '';
          dMount.setAttribute('hidden', '');
        }
        if (dInput) dInput.setAttribute('aria-expanded', 'false');
      }

      if (lastFocusedBeforeDrawer && typeof lastFocusedBeforeDrawer.focus === 'function') {
        lastFocusedBeforeDrawer.focus();
      } else if (openBtn) openBtn.focus();
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer, sig);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer, sig);
    if (overlay) overlay.addEventListener('click', closeDrawer, sig);

    var pinWrap = root.querySelector('.gx-header-wrap--pin-after');
    var pinSpacer = root.querySelector('[data-gx-pin-spacer]');
    function syncPinnedHeader() {
      if (!pinWrap) return;
      var raw = pinWrap.getAttribute('data-gx-sticky-after') || '80';
      var after = parseInt(raw, 10);
      if (isNaN(after)) after = 80;
      var pinned = window.scrollY >= after;
      var wasPinned = pinWrap.classList.contains('is-pinned');

      if (pinned && !wasPinned) {
        var h = pinWrap.offsetHeight;
        if (pinSpacer) pinSpacer.style.height = h + 'px';
        pinWrap.classList.add('is-pinned');
        return;
      }
      if (!pinned && wasPinned) {
        pinWrap.classList.remove('is-pinned');
        if (pinSpacer) pinSpacer.style.height = '0px';
        return;
      }
      if (pinned && wasPinned && pinSpacer) {
        pinSpacer.style.height = pinWrap.offsetHeight + 'px';
      }
    }
    if (pinWrap) {
      window.addEventListener('scroll', syncPinnedHeader, { passive: true, signal: ac.signal });
      window.addEventListener('resize', syncPinnedHeader, { passive: true, signal: ac.signal });
      syncPinnedHeader();
    }

    if (drawer) {
      drawer.addEventListener(
        'keydown',
        function (e) {
          if (e.key === 'Escape') {
            e.preventDefault();
            closeDrawer();
            return;
          }
          if (e.key !== 'Tab') return;

          var focusables = getDrawerFocusables();
          if (focusables.length === 0) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];

          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        },
        sig
      );
    }

    accordions.forEach(function (acc) {
      var head = acc.querySelector('.gx-drawer-acc-head');
      var panel = acc.querySelector('.gx-drawer-acc-body');
      if (!head || !panel) return;

      head.addEventListener(
        'click',
        function () {
          var wasOpen = acc.classList.contains('is-open');

          accordions.forEach(function (a) {
            a.classList.remove('is-open');
            var h = a.querySelector('.gx-drawer-acc-head');
            var p = a.querySelector('.gx-drawer-acc-body');
            if (h) h.setAttribute('aria-expanded', 'false');
            if (p) p.setAttribute('hidden', '');
          });

          if (!wasOpen) {
            acc.classList.add('is-open');
            head.setAttribute('aria-expanded', 'true');
            panel.removeAttribute('hidden');
          }
        },
        sig
      );
    });

    var testimonials = parseTrustJson(root);
    var quoteEl = root.querySelector('[data-gx-trust-quote]');
    var whoEl = root.querySelector('[data-gx-trust-who]');
    var dotsEl = root.querySelector('[data-gx-trust-dots]');
    var tIndex = 0;
    var tTimer = null;

    function renderTestimonial(i) {
      if (!quoteEl || !whoEl || !dotsEl || !testimonials.length) return;
      var item = testimonials[i];
      if (!item) return;
      quoteEl.textContent = item.quote || '';
      whoEl.textContent = item.who || '';
      dotsEl.querySelectorAll('.dot').forEach(function (d, idx) {
        var isActive = idx === i;
        d.classList.toggle('active', isActive);
        if (isActive) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    function startRotation() {
      stopRotation();
      if (!testimonials.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      tTimer = setInterval(function () {
        tIndex = (tIndex + 1) % testimonials.length;
        renderTestimonial(tIndex);
      }, 5000);
    }

    function stopRotation() {
      if (tTimer) {
        clearInterval(tTimer);
        tTimer = null;
      }
    }

    if (dotsEl && testimonials.length) {
      dotsEl.querySelectorAll('.dot').forEach(function (dot, idx) {
        dot.addEventListener(
          'click',
          function () {
            tIndex = idx;
            renderTestimonial(idx);
            startRotation();
          },
          sig
        );
      });
      renderTestimonial(0);
    }

    if (drawer && testimonials.length) {
      bundle.observer = new MutationObserver(function () {
        if (drawer.classList.contains('is-open')) startRotation();
        else stopRotation();
      });
      bundle.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function destroyGxHeader(root) {
    var bundle = roots.get(root);
    if (!bundle) return;
    bundle.controller.abort();
    if (bundle.observer) bundle.observer.disconnect();
    roots.delete(root);
  }

  function scanAndInit() {
    document.querySelectorAll('.gx-header-root').forEach(initGxHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndInit);
  } else {
    scanAndInit();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target;
    if (!container || !container.querySelector) return;
    var root = container.querySelector('.gx-header-root');
    if (root) initGxHeader(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target;
    if (!container || !container.querySelector) return;
    var root = container.querySelector('.gx-header-root');
    if (root) destroyGxHeader(root);
  });

  window.GXHeader = {
    init: initGxHeader,
    destroy: destroyGxHeader,
    scan: scanAndInit,
  };
})();
